import React, { createContext, useEffect, useState } from "react";
import NoDataFound from "../../../components/NoDataFound";
import PartLoanDetails from "./PartLoanDetails";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import PartInitiatedModal from "../Part/PartInitiatedModal";

export const PartialType = createContext();
function PartialRevokeTable({
  partUserView,
  setPartUserView,
  setTotalPages,
  setTotalRows,
  pageNo,
  rowsPerPage,
  setEndIndex,
  type,
  setPageNo,
  setReRender,
  reRender,
}) {
  const [searchValue, setSearchValue] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({
    orderId: "",
    userId: "",
  });
  const [userName, setUserName] = useState("");
  const [od, setOd] = useState(null);
  function formatToIndianRupees(num) {
    if (num === null || num === undefined) return "---";
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const [revocationUnderProcess, setRevocationUnderProcess] = useState(false);
  const [indexRerender, setIndexRerender] = useState(false);

  const fetchPartialRevokeIndex = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    let url = "";
    if (type === "revoke") {
      url = `${process.env.REACT_APP_URL}/lender/v1/revoke/partial_revoke_index?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}&type=partial_revoke`;
    } else {
      url = `${process.env.REACT_APP_URL}/lender/v1/invoke/partial_invoke_index?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}`;
    }
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(url, options);
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.invoke_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const closeLoanView = () => {
    setPartUserView(false);
  };
  useEffect(() => {
    const controller = new AbortController();
    fetchPartialRevokeIndex(controller);
    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, searchValue, indexRerender]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  return (
    <>
      {!partUserView && (
        <>
          <div className=" px-4 mt-[18px] flex justify-between items-center bg-white pt-3">
            <div className="flex items-center justify-between  w-full">
              <p className=" font-bold text-base">List of Orders</p>
              <div className="flex items-center justify-between ">
                <input
                  //   readOnly={readOnly}
                  value={searchValue}
                  onChange={(e) => {
                    setPageNo(1);
                    setSearchValue(e.target.value);
                  }}
                  type="search"
                  placeholder="Search"
                  className=" w-[210px] text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px]  focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className=" pt-3  w-full bg-white">
            {imageLoading && (
              <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {list.length < 1 && !imageLoading ? (
              <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
                <NoDataFound />
              </div>
            ) : (
              <>
                {!imageLoading && (
                  <table className="w-full box-border h-full flex flex-col">
                    <thead className="text-sm font-semibold h-full">
                      <tr className="w-full flex items-center h-[37px]">
                        <th className="text-left pl-6  pt-2 ] pb-2 w-[20%]">
                          Name
                        </th>
                        <th className={`text-left w-[15%]`}>Reference no</th>

                        <th className="text-left  w-[15%]">Distributor</th>
                        <th className="text-left  w-[8%]">Loan Type</th>
                        <th className={`text-right w-[20%] pr-8`}>
                          Pledged asset value
                        </th>
                        <th className={`text-right w-[20%] pr-6`}>
                          Pledged Date
                        </th>
                      </tr>
                    </thead>

                    <tbody className="  overflow-auto  max-h-[calc(100vh-275px)]">
                      {list?.map((data, index) => (
                        <tr
                          onClick={() => {
                            if (data.bfl_loan && !data.bfl_last_revocation) {
                              setRevocationUnderProcess(true);
                              return;
                            }

                            setOd(data.bfl_loan);
                            setUserName(data?.name);
                            setSelectedItem({
                              orderId: data?.order_uuid,
                              userId: data?.user_uuid,
                            });
                            setPartUserView(true);
                          }}
                          key={index}
                          className={`${
                            index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                          } hover:bg-[#e6ebed]  text-xs h-[37px] font-medium w-full flex items-center cursor-pointer`}
                        >
                          <td className="text-left pl-6  pt-2 pb-2 w-[20%]">
                            {data?.name || "---"}
                          </td>
                          <td className={`text-left w-[15%] text-[#004682]`}>
                            {data?.reference_no || "---"}
                          </td>

                          <td className="text-left  w-[15%]">
                            {data?.distributor_name || "---"}
                          </td>
                          <td className="text-left  w-[8%]">
                            {data?.bfl_loan ? "Overdraft" : "Term Loan"}
                          </td>
                          <td className={`text-right w-[20%] pr-8`}>
                            {data?.pledged_asset_value
                              ? formatToIndianRupees(data?.pledged_asset_value)
                              : "---"}
                          </td>
                          <td className={`text-right  w-[20%] pr-6`}>
                            {data?.pledged_date || "---"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
        </>
      )}

      {partUserView && (
        <>
          <PartialType.Provider value={type}>
            <PartLoanDetails
              closeLoanView={closeLoanView}
              selectedItem={selectedItem}
              userName={userName}
              isOd={od}
              setIndexRerender={setIndexRerender}
              setPartUserView={setPartUserView}
            />
          </PartialType.Provider>
        </>
      )}
      {revocationUnderProcess && (
        <PartInitiatedModal closeFunction={setRevocationUnderProcess} />
      )}
    </>
  );
}

export default PartialRevokeTable;
